<template>
<div class="chapter">
<div class="inner_page">
<div id="fm5">
<p class="copy">The Text Publishing Company</p>
<p class="copy">Swann House</p>
<p class="copy">22 William St</p>
<p class="copy">Melbourne Victoria 3000</p>
<p class="copy">Australia</p>
<p class="copy1"><a href="http://textpublishing.com.au" target="_blank">textpublishing.com.au</a></p>
<p class="copy"><a href="http://kategrenville.com" target="_blank">kategrenville.com</a></p>
<p class="copy1">Copyright © Kate Grenville 2011</p>
<p class="copy1">All rights reserved. Without limiting the rights under copyright above, no part of this publication shall be reproduced, stored in or introduced into a retrieval system, or transmitted in any form or by any means (electronic, mechanical, photocopying, recording or otherwise), without the prior permission of both the copyright owner and the publisher of this book.</p>
<p class="copy1">First published by The Text Publishing Company, 2011</p>
<p class="copy1">Cover design by WH Chong</p>
<p class="copy">Page design by Susan Miller</p>
<p class="copy">Typeset by J&amp;M Typesetters</p>
<p class="copy">Printed in Australia by Griffin Press, an Accredited ISO AS/NZS 1400I:2004</p>
<p class="copy">Environmental Management System printer</p>
<p class="copy1">National Library of Australia</p>
<p class="copy">Cataloguing-in-Publication entry</p>
<p class="copy1 ">Author:  Grenville, Kate, 1950-</p>
<p class="copy1">Title:     Sarah Thornhill / Kate Grenville.</p>
<p class="copy1">ISBN:    9780802194459</p>
<p class="copy1">Dewey Number: A823.4</p>
<div class="tfont">
<table width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><img alt="" src="images/img_0002.jpg"/></td>
<td valign="top">The paper this book is printed on is certified against the Forest Stewardship Council® Standards. Griffin Press holds FSC chain of custody certification SGS-COC-005088. FSC promotes environmentally responsible, socially beneficial and economically viable management of the world’s forests.</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?18a26c34